import { formatDate, formatTime, formatProfitLabel, formatTransactionErrorLabel, getShortTransactionLogId } from '@smarttransit/common'

const LOG_STATUS_LABELS = {
  confirmed: 'confirmed',
  completed: 'completed',
  processing: 'processing',
  pending: 'pending',
  cancelled: 'cancelled',
  rejected: 'rejected',
  error: 'error',
  timedout: 'timed out'
}

function formatLogStatusLabel (logStatus) {
  if (!logStatus) {
    return ''
  }
  return LOG_STATUS_LABELS[logStatus] || String(logStatus).replace(/_/g, ' ')
}

function formatDateTime (date) {
  if (!date) {
    return ''
  }
  return `${formatDate(date)} ${formatTime(date)}`
}

export default {
  name: 'transaction-details-dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    transaction: {
      type: Object,
      default: null
    }
  },
  computed: {
    dialogModel: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    typeLabel () {
      const iconData = this.transaction && this.transaction.logTypeIconData
      return (iconData && iconData.label) || 'Transaction'
    },
    statusLabel () {
      return formatLogStatusLabel(this.transaction && this.transaction.logStatus)
    },
    profitLabel () {
      const transaction = this.transaction
      if (!transaction) {
        return ''
      }
      return formatProfitLabel(
        transaction.logType,
        transaction.amount,
        transaction.conversionRatePercent,
        transaction.currencyPrefix || ''
      )
    },
    customerTransactionIdLabel () {
      const referenceId = this.transaction && this.transaction.transactionLogReferenceId
      return referenceId ? getShortTransactionLogId(referenceId) : ''
    },
    errorLabel () {
      return formatTransactionErrorLabel(this.transaction)
    },
    dateCreatedLabel () {
      return formatDateTime(this.transaction && this.transaction.dateCreated)
    },
    dateUpdatedLabel () {
      return formatDateTime(this.transaction && this.transaction.dateUpdated)
    },
    hasAccount () {
      const transaction = this.transaction
      return !!(transaction && (transaction.passengerPhoneNumberLabel || transaction.phoneNumberLabel))
    },
    hasBalance () {
      const transaction = this.transaction
      return !!(transaction && (transaction.profileBalanceBeforeLabel || transaction.profileBalanceAfterLabel))
    }
  },
  methods: {
    closeDialog () {
      this.dialogModel = false
    }
  }
}

